import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { QUICK_LAUNCH } from "../lib/windowManager/registry";
import { Plus } from "lucide-react";

// Mobile quick-add: a sticky FAB that opens New Quote / Invoice / Expense. Reads
// the same QUICK_LAUNCH registry rows the Start Menu uses — one source of truth.
export default function QuickAddFab() {
  const navigate = useNavigate();
  const { canEdit } = useAuth();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    function onDown(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    function onKey(e) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (!canEdit) return null;

  function go(route) {
    setOpen(false);
    navigate(route);
  }

  return createPortal(
    <div ref={wrapRef} className="kb-quickadd" data-testid="quick-add">
      {open && (
        <div className="kb-quickadd-menu win-window" role="menu" aria-label="Quick add">
          {QUICK_LAUNCH.map((entry) => (
            <button
              key={entry.id}
              type="button"
              role="menuitem"
              className="kb-quickadd-item"
              onClick={() => go(entry.route)}
              data-testid={`quick-add-${entry.id}`}
            >
              <span aria-hidden="true">{entry.icon}</span> {entry.title}
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        className="win-btn win98-fab"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="true"
        aria-expanded={open}
        aria-label="Quick add"
      >
        <Plus className="w-6 h-6" />
      </button>
    </div>,
    document.body
  );
}
